/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Preview_EmptyInputs */

const cs_portals_preview_empty = /** @type {(inputs: Portals_Preview_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zatím žádný náhled.`)
};

const en_portals_preview_empty = /** @type {(inputs: Portals_Preview_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No preview yet.`)
};

/**
* | output |
* | --- |
* | "No preview yet." |
*
* @param {Portals_Preview_EmptyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_preview_empty = /** @type {((inputs?: Portals_Preview_EmptyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Preview_EmptyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_preview_empty(inputs)
	return cs_portals_preview_empty(inputs)
});